



import { useCart } from '~/composables';
import { getItem, mergeItem } from '~/helpers/asyncLocalStorage';
import { defineComponent, useRouter, useRoute, useContext } from '@nuxtjs/composition-api';

export default defineComponent({
  async setup() {
    const router = useRouter();
    const route = useRoute();
    const { app } = useContext();
    const { addItem, error } = useCart();

    if (!process.client) {
      return;
    }

    await addItem({
      product: {
        __typename: 'SimpleProduct',
        sku: 'WT01-S-Blue',
      },
      quantity: 1,
    });

    if (!error?.value?.addItem) {
      const checkout = await getItem('checkout');

      if (!checkout) {
        await mergeItem('checkout', {
          'user-account': {
            email: 'testuser@demoshop.com',
            firstname: 'Great',
            is_subscribed: false,
            lastname: 'Customer',
            password: '',
          },
        });
      }
    }

    router.push(
      app.localeRoute({
        name: error?.value?.addItem ? 'cart' : 'shipping',
        query: { ...route.value.query },
      }),
    );
  },
});
